import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { storage } from './firebase-config';

export const getLogoImageUrl = async (bussinessId) => {
  const storageRef = ref(storage, `${bussinessId}.png`);
  const logoUrl = await getDownloadURL(storageRef)
  return logoUrl;
};

export const uploadLogoImage = async (businessId, file) => {
  const storageRef = ref(storage, `${businessId}.png`);
  await uploadBytes(storageRef, file);
};
